module.exports = __webpack_public_path__ + "img/BARI.9a6bc0df.png";